export default __webpack_public_path__ + "static/media/MailIcon.22923392.svg";